<template>
  <span>
    <a-button
      v-show="!readonly && status=='1'"
      :id="'AttachButton' + _uid"
      :loading="configLoading"
    >
      盖章的报价确认函上传
    </a-button>
    <div class="mt-1" style="color: red" v-show="status == '1'">
      只支持不超过10M的PDF文件
    </div>
    <span style="color: red" v-if="fileTips">{{ fileTips }}</span>
    <div v-for="(file, idx) in uploadFiles" :key="file.id" class="file_list">
      <a @click="onView(idx, file.name)">
        <span>{{ file.name }}</span>
      </a>
      <div style="background: #e8e8e8">
        <div
          v-show="file.percent < 100"
          class="progress"
          :style="{ width: file.percent + '%' }"
        ></div>
      </div>
      <div>
        <div v-if="hasError" style="color: red">{{ file.response }}</div>
        <small v-else>{{ file.size }}</small>
        <a-popconfirm
          v-show="!readonly && !deleteVisabled"
          title="是否确认删除?"
          @confirm="onDelete(file.id)"
        >
          <a-button type="link" icon="delete" style="color: red"></a-button>
        </a-popconfirm>
      </div>
    </div>
    <a-modal
      title="提示"
      :visible="ModalVisible"
      :footer="null"
      :closable="false"
    >
      <p>{{ ModalText }}</p>
    </a-modal>
  </span>
</template>

<script>
import { ACCESS_TOKEN } from "@/store/mutation-types";
import plupload from "plupload";

export default {
  //单轮竞价确认函上传附件
  name: "SingleProcessUploadSelector",
  props: {
    referId: {
      type: String,
      required: true,
      default: "",
    },
    status: {
      type: String,
      required: true,
    },
    configKey: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    deleteVisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    max: {
      type: Number,
      required: false,
    },
    // 此字段仅用作融合到 Form 检验必须上传功能
    value: {
      type: String,
    },
    fileTips: {
      type: String,
      required: false,
    },
  },
  mounted() {
    // console.log(this.readonly)
    this.loadConfig();
    this.refreshData();
  },
  watch: {
    referId(val) {
      this.refreshData();
    },
  },
  data() {
    return {
      configLoading: true,
      uploading: false,
      hasError: false,
      config: null,
      uploadFiles: [],
      ModalText:"请稍等",
      ModalVisible:false,
    };
  },
  methods: {
    loadConfig() {
      const that = this;
      that.$http
        .get("/api/1/attachment/spl/config.json?key=" + that.configKey)
        .then(function (response) {
          if (response.code === 200) {
            that.configLoading = false;
            that.config = response.result;
            that.initUploader();
          }
        });
    },
    onView(idx, fileName) {
      let that = this;
      let file = this.uploadFiles[idx];
      this.ModalText="正在解密下载文件，请稍候";
      this.ModalVisible=true
      that.$http
        .get(
          "/api/1/attachment/spl/single_detail_process_download.json?fileLink=" +
            file.url,
          { responseType: "blob" }
        )
        .then(function (res) {
          let blob = new Blob([res], {
            type:
              "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let elink = document.createElement("a");
          document.body.appendChild(elink);
          elink.style.display = "none"; // 隐藏起来
          elink.download = fileName;
          // 兼容webkix浏览器，处理webkit浏览器中herf自动添加blob前缀，默认在浏览器打开而不是下载
          const URL = window.URL || window.webkitURL;
          elink.href = URL.createObjectURL(blob); // 通过createObjectURL方法转换成对象url
          that.ModalVisible=false;
          that.$message.success("解密下载文件成功");
          elink.click();
          document.body.removeChild(elink);
          URL.revokeObjectURL(elink.href); // 释放URL 对象
        });
      // window.open(file.url)
    },
    getFileIndex(id) {
      return this.uploadFiles.findIndex((item) => item.id === id);
    },
    refreshData() {
      const that = this;
      if (!that.referId) {
        return;
      }
      that.$http
        .get(
          "/api/1/attachment/spl/attachments.json?referId=" +
            that.referId +
            "&configKey=" +
            that.configKey
        )
        .then(function (response) {
          if (response.code === 200) {
            let files = response.result.map((item) => {
              let downloadUrl = null;
              if (item.isExternal === 1) {
                downloadUrl = item.downloadUrl;
              } else {
                downloadUrl =
                  process.env.VUE_APP_WEB_SERVER +
                  "/api/1/attachment/spl/download?id=" +
                  item.id;
              }
              return {
                id: item.id,
                name: item.name,
                extension: item.extension,
                size: item.sizeDesc,
                percent: 100,
                response: null,
                clazz: "ant-upload-list-item-done",
                url: downloadUrl,
              };
            });
            that.uploadFiles = files;
            if (that.uploadFiles.length > 0) {
              that.sendEvent();
            }
            that.getFileLen();
          }
        });
    },
    onDelete(fileId) {
      const that = this;
      that.$http
        .get("/api/1/attachment/spl/delete.json?id=" + fileId)
        .then(function (response) {
          if (response.code === 200) {
            that.uploadFiles = that.uploadFiles.filter((file) => file.id !== fileId);
          }
          that.sendEvent();
        });
    },
    initUploader() {
      const that = this;
      let mimeTypes = [];
      let mime = that.config.extension.join(",");
      if (!mime.includes("***")) {
        mimeTypes.push({ title: "文件类型", extensions: mime });
      }
      const uploader = new plupload.Uploader({
        headers: { "X-Auth-Token": that.$ls.get(ACCESS_TOKEN) },
        runtimes: "html5,flash,html4",
        browse_button: "AttachButton" + that._uid,
        // url: '/api/1/attachment/spl/plupload.json',
        url: "/api/1/attachment/spl/single_detail_process_upload.json",
        flash_swf_url: "../../../static/plupload/2.3.6/Moxie.swf",
        filters: {
          mime_types: mimeTypes,
          max_file_size: that.config.maxSize / 1024 + "kb",
          prevent_duplicates: false,
        },
        init: {
          BeforeUpload: function () {
            uploader.setOption("multipart_params", {
              referId: that.referId,
              key: that.configKey,
            });
            that.ModalVisible=true
            that.ModalText="正在加密上传文件，请稍候";
          },
          // PostInit: function () {
          //   uploader.setOption('multipart_params', { referId: that.referId, key: that.configKey })
          // },
          FilesAdded: function (up, files) {
            //that.$emit('change', '1')
            if (that.uploadFiles.length >= that.max) {
              that.$warning({ title: "最多上传 " + that.max + " 个文件" });
              return;
            }
            plupload.each(files, function (file) {
              that.uploadFiles.push({
                id: file.id,
                name: file.name,
                size: plupload.formatSize(file.size),
                percent: 1,
                response: null,
                clazz: "ant-upload-list-item-uploading",
              });
            });
            this.uploading = true;
            uploader.start();
          },
          UploadProgress: function (up, file) {
            const idx = that.getFileIndex(file.id);
            if (idx < 0) {
              return;
            }
            that.uploadFiles[idx].percent = file.percent;
          },
          FileUploaded: function (up, file, info) {
            let text = info.response;
            let result = /<pre[^>]*>(.*?)<\/pre>/g.exec(info.response);
            if (result) {
              text = result[1];
            }
            let response = JSON.parse(info.response);
            const idx = that.getFileIndex(file.id);
            if (response.error) {
              that.hasError = true;
              that.uploadFiles[idx].percent = file.percent;
              that.uploadFiles[idx].response = response.error.message;
              that.uploadFiles[idx].clazz = "ant-upload-list-item-error";
              that.uploadFiles[idx].extension = file.name.split(".").pop();
            } else {
              that.uploadFiles[idx].id = response.id;
              that.uploadFiles[idx].percent = file.percent;
              that.uploadFiles[idx].response = null;
              that.uploadFiles[idx].clazz = "ant-upload-list-item-done";
              if (response.isExternal === 1) {
                that.uploadFiles[idx].url = response.result;
              } else {
                that.uploadFiles[idx].url =
                  "/api/1/attachment/spl/download?id=" + response.id;
              }
              that.uploadFiles[idx].extension = file.name.split(".").pop();
            }
            that.uploadSuceesEvent();
            that.sendEvent();
          },
          UploadComplete: function (up, files) {
            this.uploading = false;
          },
          Error: function (up, err) {
            console.log(err);
            that.uploading = false;
            let message =
              err.message === "File size error."
                ? "文件大小超过2M，请更换文件，重新上传！"
                : err.message;
            that.$message.error(message);
          },
        },
      });
      uploader.init();
    },
    sendEvent() {
      if (this.uploadFiles.length === 0) {
        this.$emit("change", "");
      } else {
        this.$emit("change", this.uploadFiles.length + "");
      }
    },
    uploadSuceesEvent() {
      this.ModalVisible=false
      if (this.uploadFiles.length === 0) {
        this.$emit("uploadSuccess", "");
      } else {
        this.$emit("uploadSuccess", this.uploadFiles.length + "");
      }
    },
    getFileLen() {
      this.$emit("fileLen", this.uploadFiles.length);
    },
    getSize() {
      return this.uploadFiles.length;
    },
  },
};
</script>

<style scoped>
.file_list {
  position: relative;
  padding: 10px 0;
  border-bottom: 1px solid #e8e8e8;
  line-height: initial;
}

.file_list .progress {
  height: 4px;
  background: #52c41a;
}

.file_list:nth-last-child(1) {
  border-bottom: none;
}

.file_list a {
  position: relative;
}

.file_list a span {
  display: inline-block;
  white-space: nowrap;
  max-width: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file_list a > small {
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}

.file_list div small {
  display: block;
  color: #808080;
}

.file_list div button {
  position: absolute;
  right: 0;
  top: 10px;
  border: none;
  font-size: 12px;
  background: none;
  line-height: 21px;
  color: #808080;
}

.file_list div button:hover {
  color: #ff0000;
  cursor: pointer;
}
/deep/ .anticon-delete {
  font-size: 18px;
}
</style>
